import React from "react";
import { cn } from "@/lib/utils/cn";

interface CommandProps extends React.HTMLAttributes<HTMLDivElement> {}

export function Command({ className, ...props }: CommandProps) {
  return (
    <div
      className={cn(
        "flex h-full w-full flex-col overflow-hidden rounded-md border border-border bg-card text-foreground",
        className
      )}
      {...props}
    />
  );
}
Command.displayName = "Command";

interface CommandInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export function CommandInput({ className, ...props }: CommandInputProps) {
  return (
    <div className="flex items-center border-b border-border px-3" cmd-input="">
      <input
        className={cn(
          "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        {...props}
      />
    </div>
  );
}
CommandInput.displayName = "CommandInput";

interface CommandListProps extends React.HTMLAttributes<HTMLUListElement> {}

export function CommandList({ className, ...props }: CommandListProps) {
  return (
    <div className="overflow-y-auto overflow-x-hidden">
      <ul className={cn("p-1", className)} {...props} />
    </div>
  );
}
CommandList.displayName = "CommandList";

interface CommandEmptyProps extends React.HTMLAttributes<HTMLDivElement> {}

export function CommandEmpty({ className, ...props }: CommandEmptyProps) {
  return (
    <div className={cn("py-6 text-center text-sm", className)} {...props}>
      <p className="text-muted-foreground">No results found.</p>
      <p className="mt-1 text-xs text-muted-foreground/70">Try a different search term or browse all content.</p>
    </div>
  );
}
CommandEmpty.displayName = "CommandEmpty";

interface CommandGroupProps extends React.HTMLAttributes<HTMLDivElement> {}

export function CommandGroup({ className, ...props }: CommandGroupProps) {
  return (
    <div className={cn("overflow-hidden p-1", className)} {...props} />
  );
}
CommandGroup.displayName = "CommandGroup";

interface CommandItemProps extends React.HTMLAttributes<HTMLLIElement> {
  value?: string;
}

export function CommandItem({ className, ...props }: CommandItemProps) {
  return (
    <li
      className={cn(
        "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none aria-selected:bg-accent aria-selected:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        className
      )}
      {...props}
    />
  );
}
CommandItem.displayName = "CommandItem";

interface CommandSeparatorProps extends React.HTMLAttributes<HTMLHRElement> {}

export function CommandSeparator({ className, ...props }: CommandSeparatorProps) {
  return (
    <hr className={cn("-mx-1 my-1 h-px bg-border", className)} {...props} />
  );
}
CommandSeparator.displayName = "CommandSeparator";

interface CommandShortcutProps extends React.HTMLAttributes<HTMLSpanElement> {}

export function CommandShortcut({ className, ...props }: CommandShortcutProps) {
  return (
    <span className={cn("ml-auto text-xs tracking-widest text-muted-foreground", className)} {...props} />
  );
}
CommandShortcut.displayName = "CommandShortcut";
